import { privateAxios } from './private.axios'

export const configurateInterceptors = ( token ) => {
    privateAxios.defaults.headers.common["Authorization"] = `${token}`
}